<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td>
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPagina(1)"
                title="Buscar registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >search</i
                >
                Buscar
              </button>
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                  >add_box</i
                >
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Imagen</th>
          <th scope="col">Nombre</th>
          <th scope="col">Tipo</th>
          <th scope="col">PlanillaNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="planilladoc in datosPaginados"
          :key="planilladoc.idPlanillaDoc"
        >
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(planilladoc.idPlanillaDoc)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(planilladoc.idPlanillaDoc)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <img
              :src="direccionImagen(planilladoc.idPlanillaDoc)"
              :style="estiloImagen"
            />
          </td>
          <td>{{ planilladoc.nombre }}</td>
          <td>{{ planilladoc.tipo }}</td>
          <td>{{ planilladoc.planillaNombre }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deletePlanillaDoc(planilladoc.idPlanillaDoc)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idPlanillaDoc" class="form-label"
                      >IdPlanillaDoc</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idPlanillaDoc"
                      name="idPlanillaDoc"
                      v-model="datoPlanillaDoc.idPlanillaDoc"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Planilla -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPlanilla" class="form-label"> Planilla</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idPlanilla"
                      name="idPlanilla"
                      v-model="datoPlanillaDoc.idPlanilla"
                    >
                      <option
                        v-for="planilla in planillas"
                        :value="planilla.idPlanilla"
                        :key="planilla.idPlanilla"
                      >
                        {{ planilla.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Planilla -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="imagen" class="form-label">Imagen</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="imagen"
                      name="imagen"
                      v-model="datoPlanillaDoc.imagen"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Imagen</label>
                  </div>
                  <div class="col-10">
                    <img
                      :src="direccionImagen(datoPlanillaDoc.idPlanillaDoc)"
                      :style="estiloImagen"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="imagen" class="form-label">Imagen</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="file"
                      class="form-control"
                      id="imagenCarga"
                      name="imagenCarga"
                      accept="image/*"
                      @change="handleFileUpload"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Nombre</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      v-model="datoPlanillaDoc.nombre"
                      style="text-transform: uppercase"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="tipo" class="form-label">Tipo</label>
                  </div>
                  <div class="col-10">
                    <textarea
                      class="form-control"
                      id="tipo"
                      name="tipo"
                      v-model="datoPlanillaDoc.tipo"
                      style="text-transform: uppercase"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <div class="me-auto">
              <button
                type="button"
                id="send"
                class="btn btn-light"
                data-bs-dismiss="modal"
                title="Cerrar"
              >
                <i
                  class="material-icons"
                  style="font-size: 32px; color: orangered; cursor: pointer"
                  >meeting_room</i
                >
              </button>
            </div>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarPlanillaDoc"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarPlanillaDoc"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  data() {
    return {
      planilladocs: [],
      datoPlanillaDoc: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      planillas: [],
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
  },
  methods: {
    totalPaginas() {
      return Math.ceil(this.planilladocs.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwplanilladocs/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.planilladocs = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.planilladocs.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwplanilladocs")
        .then((response) => {
          this.planilladocs = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.planilladocs.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = ["idPlanilla", "imagen", "nombre", "tipo"];
      const requiredFieldsText = ["idPlanilla", "imagen", "nombre", "tipo"];
      return validarForm(
        this.datoPlanillaDoc,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarPlanillaDoc() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/planilladocs",
            this.datoPlanillaDoc
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "PlanillaDoc creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarPlanillaDoc() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/planilladocs",
            this.datoPlanillaDoc
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "PlanillaDoc creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoPlanillaDoc = {};
      this.titulo = "Crear Empresa: Imagen";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idPlanillaDoc) {
      this.modalWindow = true;
      if (idPlanillaDoc != null) {
        api.get("/vwplanilladocs/" + idPlanillaDoc)
          .then((resp) => {
            this.datoPlanillaDoc = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar Empresa: Imagen";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idPlanillaDoc) {
      if (idPlanillaDoc != null) {
        this.$router.push("/planilladocmd/" + idPlanillaDoc);
      }
    },
    async deletePlanillaDoc(idPlanillaDoc) {
      try {
        await api.delete("/planilladocs/" + idPlanillaDoc
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
  },
};
</script>
